import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { ThemeProvider } from './contexts/ThemeContext';
import Navigation from './components/Navigation';
import AppleWatchNotice from './components/AppleWatchNotice';
import Hero from './components/Hero';
import Features from './components/Features';
import WatchShowcase from './components/WatchShowcase';
import IOSFeatures from './components/IOSFeatures';
import IOSGallery from './components/IOSGallery';
import WatchOSGallery from './components/WatchOSGallery';
import DivePlanning from './components/DivePlanning';
import BreathingExercises from './components/BreathingExercises';
import Safety from './components/Safety';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';

function PageMeta() {
  const location = useLocation();

  useEffect(() => {
    let title = 'ZDIVE - Your Ultimate Diving Companion for iOS & watchOS';
    let description = 'ZDIVE - Professional diving tracker and dive analysis for Apple Watch and iOS. Bühlmann ZH-L16C decompression, dive planning, logbook, and breathing exercises.';
    let canonical = 'https://zdive.app/';

    if (location.pathname === '/privacy-policy') {
      title = 'Privacy Policy - ZDIVE Diving App';
      description = 'Privacy Policy for ZDIVE. Learn how we protect your dive data, location telemetry, and Apple Health information.';
      canonical = 'https://zdive.app/privacy-policy';
    } else if (location.pathname === '/terms-of-service') {
      title = 'Terms of Service - ZDIVE Diving App';
      description = 'Terms of Service and diving safety disclaimers for ZDIVE dive logging and planning application.';
      canonical = 'https://zdive.app/terms-of-service';
    }

    document.title = title;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', description);

    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) canonicalLink.setAttribute('href', canonical);

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title);

    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', description);

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', canonical);

    const twTitle = document.querySelector('meta[name="twitter:title"]');
    if (twTitle) twTitle.setAttribute('content', title);

    const twDesc = document.querySelector('meta[name="twitter:description"]');
    if (twDesc) twDesc.setAttribute('content', description);

    // Track page view across all pages in Google Analytics 4
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-Q5M7NFM1C0', {
        page_title: title,
        page_location: window.location.href,
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}

// Home component for the main landing page
function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <AppleWatchNotice />
      <Hero />
      <IOSGallery />
      <WatchOSGallery />
      <Features />
      <WatchShowcase />
      <IOSFeatures />
      <DivePlanning />
      <BreathingExercises />
      <Safety />
    </>
  );
}

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  return (
    <ThemeProvider>
      <div className="App">
        <PageMeta />
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;